import React, { Component } from 'react';
import { fetchJson, userAction } from '@/util/helpers/ajax-helpers';
import { SQL_FROM } from '../../../util/enums/EnumLayers';
import AceEditor from '../../AceEditor';
import SchemaTable from '../../../util/SchemaTable';
import SchemaColumn from '../../../util/SchemaColumn';
import { SchemaEntitiesSearch } from './subcomponents/SchemaEntitiesSearch';
import { SchemaEntitiesList } from '../../SchemaEntitiesList';
import ModalLoading from '../ModalLoading';

class ModalSqlEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: null,
    };
  }

  static modalType() {
    return SQL_FROM;
  }

  static reducer(modals) {
    return modals.sqlEditorModal;
  }

  static title() {
    return 'SQL';
  }

  componentDidMount() {
    if (!this.props.state.isExport) {
      fetchJson('/tables_and_columns').then((json) => {
        this.setState({
          tables: json.tables.map(
            (t) =>
              new SchemaTable(
                t.schema,
                t.table,
                t.columns.map((c) => new SchemaColumn(c._name, c._type)),
              ),
          ),
        });
      });
    }
  }

  copySQL() {
    try {
      this._textareas.select();
      document.execCommand('copy');
      $(this._notification).removeClass('hidden');
      userAction('use-copy-SQL');
      setTimeout(() => {
        $(this._notification).addClass('hidden');
      }, 2500);
    } catch (err) {
      alert('Oops, unable to copy');
    }
  }

  render() {
    const { userInteraction, state } = this.props;

    this._userInteraction = userInteraction;
    const errorMsg = state.errorMsg ? (
      <div className="alert alert-danger">{state.errorMsg}</div>
    ) : null;
    const loading = !state.checkingSql ? null : (
      <ModalLoading className="pull-right" />
    );

    const sqlOnChange = (newValue) => {
      if (!state.isExport) {
        userInteraction({ section: 'sqlChange', sql: newValue })();
      }
    };
    return (
      <div>
        {this.state.tables && (
          <SchemaEntitiesSearch>
            <SchemaEntitiesList tables={this.state.tables} />
          </SchemaEntitiesSearch>
        )}
        <AceEditor
          onChange={sqlOnChange}
          initialSql={this.props.state.sql}
          readOnly={this.props.state.isExport}
          schema={this.state.tables}
        />
        <div>
          {state.isExport ? (
            <div className="position-relative">
              <button
                className="btn btn-outline-dark copyBtn"
                onClick={this.copySQL.bind(this)}
              >
                <img className="copy-icon" src="/img/copy.png" />
                copy SQL to clipboard
              </button>
              <span
                className="copySuccess hidden"
                ref={(d) => (this._notification = d)}
              >
                Copied to clipboard!
              </span>
              <textarea
                data-gramm="false"
                className="hidden-ta"
                onChange={() => true}
                value={this.props.state.sql}
                ref={(ta) => (this._textareas = ta)}
              />
            </div>
          ) : null}
          {loading}
          {errorMsg}
          {state.isExport ? null : (
            <div className="sql-blurb">
              <div>
                <hr />
                <p>
                  Instead of writing SQL, why not try Trevor's interface?&nbsp;
                  {state.showBlurb ? null : (
                    <a
                      href="#"
                      onClick={userInteraction({ section: 'showMe' })}
                    >
                      show me
                    </a>
                  )}
                </p>
              </div>
              {!state.showBlurb ? null : (
                <div>
                  <p>To do a:</p>
                  <br />
                  <ul>
                    <li>
                      <b>WHERE</b>: click a column header, then click
                      'rows'-&gt;'filter rows by ...'
                    </li>
                    <li>
                      <b>ORDER BY</b>: click a column header, then click
                      'rows'-&gt;'sort rows by ...'
                    </li>
                    <li>
                      <b>GROUP BY</b>: click 'summarize'
                    </li>
                    <li>
                      <b>HAVING</b>: perform a 'summarize' step, then click
                      'rows'-&gt;'filter rows'
                    </li>
                    <li>
                      <b>JOIN</b>: click 'join table'
                    </li>
                    <li>
                      <b>SELECT</b>: click 'columns', then click 'show / hide
                      columns'
                    </li>
                    <li>
                      <b>COUNT(*)</b>: click 'summarize'
                    </li>
                    <li>
                      <b>SUM</b>: click 'summarize'
                    </li>
                    <li>
                      <b>something more complex</b>: click 'columns'-&gt;'add
                      new column' and check out our 'cheatsheet'
                    </li>
                  </ul>
                  <br />
                  <p>
                    Can't find what you need? Message us via the Intercom in the
                    bottom right corner.
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ModalSqlEditor;
